import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import { Section, Badge } from "@/components/ui/kit";
import { toast } from "sonner";
import { Download, FileText } from "lucide-react";

export default function DownloadCentre() {
  const [d, setD] = useState({ documents: [], donorType: "" });
  useEffect(() => { api.get("/donor/download-centre").then(r => setD(r.data.data)); }, []);
  const preview = (doc) => toast.info(`${doc.name} — placeholder document. Production will render the actual PDF here.`);

  return (
    <div className="space-y-6" data-testid="download-centre">
      <Section title="Download Centre" kicker="Receipts • Certificates • Reports"
        right={<Badge tone={d.donorType === "CORPORATE" ? "indigo" : "brand"}>{d.donorType}</Badge>} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {d.documents.map((doc) => (
          <button key={doc.type} data-testid={`download-${doc.type}`} onClick={() => preview(doc)}
            className="text-left rounded-xl border border-emerald-900/10 bg-white p-5 hover:bg-emerald-50/50 transition-colors group">
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-emerald-900/5 flex items-center justify-center group-hover:bg-emerald-900/10 transition-colors">
                  <FileText className="w-5 h-5 text-emerald-800" />
                </div>
                <div>
                  <div className="font-display font-semibold text-emerald-950">{doc.name}</div>
                  <div className="text-xs text-muted-foreground mono">{doc.type}</div>
                </div>
              </div>
              <Download className="w-4 h-4 text-emerald-700 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </button>
        ))}
      </div>
      <div className="text-xs text-muted-foreground">
        Note: In this preview environment, documents open placeholder previews. Wire your PDF generator to enable production downloads.
      </div>
    </div>
  );
}
